import { useRef, useState } from "react";
import { Link2, Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, imgUrl } from "../lib/api";

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd);
  return data.url;
};

export const ImageInput = ({ value, onChange, testId }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [showUrl, setShowUrl] = useState(false);
  const [url, setUrl] = useState("");
  const run = async (fn) => {
    setBusy(true);
    try { onChange(await fn()); setShowUrl(false); setUrl(""); } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  const pick = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (f) run(() => uploadImage(f));
  };
  const importUrl = () => url.trim() && run(async () => (await api.post("/admin/upload-url", { url: url.trim() })).data.url);

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        {value ? <img src={imgUrl(value)} alt="" className="h-20 w-28 rounded-lg border border-white/10 object-cover" /> : <div className="h-20 w-28 rounded-lg bg-white/5" />}
        <div className="flex flex-col gap-1.5">
          <button type="button" onClick={() => ref.current?.click()} className="btn-ghost !px-4 !py-1.5 !text-sm" disabled={busy} data-testid={testId}>
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {value ? "Replace" : "Upload"}
          </button>
          <button type="button" onClick={() => setShowUrl((v) => !v)} className="flex items-center gap-1 text-xs text-[#60A5FA] hover:underline" data-testid={`${testId}-url-toggle`}><Link2 className="h-3 w-3" />From link</button>
        </div>
      </div>
      {showUrl && (
        <div className="flex gap-2">
          <input className="field !py-2 text-xs" placeholder="Paste image link (e.g. from a catalog page)" value={url} onChange={(e) => setUrl(e.target.value)} data-testid={`${testId}-url-input`} />
          <button type="button" onClick={importUrl} disabled={busy} className="btn-red !px-4 !py-2 !text-sm" data-testid={`${testId}-url-import`}>Import</button>
        </div>
      )}
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/gif" hidden onChange={pick} />
    </div>
  );
};
